import InstructionBlock from './InstructionBlock';

export default InstructionBlock;